import { dbService } from "fbase";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import Step2 from "./Step2";
import Step3 from "./Step3";
import { useRecoilValue } from "recoil";
import { userData } from "states/atoms";

const { useState } = require("react");
const { useHistory } = require("react-router-dom");
const { default: Step1 } = require("./Step1");

const Certification = ({ loggedInUser }) => {
  const [page, setPage] = useState(0);
  const history = useHistory();
  const userInfo = useRecoilValue(userData);

  const itemLayout = {
    form: {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    },
    button: {
      wrapperCol: { span: 24, offset: 0 },
    },
  };

  const [step1Data, setStep1Data] = useState({
    injunction: {
      reason: [],
      reasonEtc: null,
      targetProperty: null,
      occupantInfo: null,
      vacatehouseFiled: "n",
    },
  });

  const [step2Data, setStep2Data] = useState({
    contract: {
      date: null,
      deposit: {
        amount: null,
      },
      monthlyRent: {
        exist: "n",
        amount: null,
        date: null,
      },
      address: null,
      endDate: null,
    },
  });

  const [step3Data, setStep3Data] = useState({
    description: null,
    contact: null,
    promotionCode: null,
  });

  const onPrev = () => {
    setPage(page - 1);
  };

  const onNext = () => {
    setPage(page + 1);
  };

  const onSubmit = async () => {
    const formattedStep2Data = {
      contract: {
        ...step2Data.contract,
        date: step2Data.contract.date
          ? moment(step2Data.contract.date).format("YYYY-MM-DD")
          : null,
        endDate: step2Data.contract.endDate
          ? moment(step2Data.contract.endDate).format("YYYY-MM-DD")
          : null,
      },
    };

    const serviceData = {
      ...step1Data,
      ...formattedStep2Data,
      ...step3Data,
      userId: loggedInUser.uid,
    };

    const uuid = uuidv4();
    try {
      await dbService.collection("requests_temp").add({
        serviceType: "injunction",
        serviceId: uuid,
        createdAt: Date.now(),
        service_data: serviceData,
        userId: loggedInUser.uid,
        clientName: userInfo.name,
        status: "submitted",
      });
      history.push("/submit/success");
    } catch (err) {
      history.push("/submit/fail");
    }
  };

  const steps = [
    {
      title: "가처분 사유",
      content: (
        <Step1
          data={step1Data}
          setData={setStep1Data}
          onNext={onNext}
          itemLayout={itemLayout}
        />
      ),
    },
    {
      title: "임대차 계약 정보",
      content: (
        <Step2
          data={step2Data}
          setData={setStep2Data}
          onPrev={onPrev}
          onNext={onNext}
          itemLayout={itemLayout}
        />
      ),
    },
    {
      title: "추가 정보",
      content: (
        <Step3
          data={step3Data}
          setData={setStep3Data}
          onPrev={onPrev}
          onNext={onSubmit}
          itemLayout={itemLayout}
        />
      ),
    },
  ];

  return (
    <>
      <div className="steps-content">{steps[page].content}</div>
    </>
  );
};

export default Certification;
